import React, {useEffect} from "react";
import Header from "../main-Header/Header";
// import HomepageContent from "../Pages/HomepageContent";
// import Footer from "../Footer/Footer";
// import LandingPage from "../Pages/LandingPage";
import SplashLandingPage from "../Pages/SplashLandingPage";

import { GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

// const Home = () => {
//   return (
//         <React.Fragment>
//           <Header />
//           <HomepageContent />
//           <Footer />
//         </React.Fragment>
//   );
// };

const Home = ({accountLoginSlug}) => {
    useEffect(()  =>  {
        document.documentElement.style.setProperty('--global-landing-page-color', '#00424d');
        // document.documentElement.style.setProperty('--global-footer-color', '#457B9D');
    }, []);

    return (
        <div>
            {/*<LandingPage />*/}
            <SplashLandingPage accountLoginSlug={accountLoginSlug}/>
        </div>
    );
};

export default Home;
